
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us-stocks/[pn1]",
      function () {
        return require("private-next-pages/us-stocks/[pn1]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us-stocks/[pn1]"])
      });
    }
  